import { Link } from 'react-router-dom';

interface SurveyLink {
    to: string;
    title: string;
    description: string;
}

const SURVEYS: SurveyLink[] = [
    { to: '/mrs15', title: 'MRS-15', description: 'Military Readiness Scale – 15 self-report items covering psychological, technical, and physical readiness.' },
    { to: '/nsi22', title: 'NSI-22', description: 'Neurobehavioral Symptom Inventory – 22 items rating symptoms experienced in the last 2 weeks.' },
    { to: '/acq', title: 'ACQ', description: 'Activity Characteristics Questionnaire – 27 items reporting time spent yesterday in activities with specific characteristics.' },
];

export default function Surveys() {
    return (
        <>
            <div className="breadcrumb">neuroFit &gt; Surveys</div>
            <div className="title">Surveys</div>
            <div className="surveyList">
                {SURVEYS.map(survey => (
                    <Link key={survey.to} to={survey.to} className="surveyButton">
                        <div className="surveyButtonTitle">{survey.title}</div>
                        <div className="surveyButtonDescription">{survey.description}</div>
                    </Link>
                ))}
            </div>
        </>
    );
}
